export const DEFAULT_GROUP_PERIOD = 86400;
